import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';

import { themes } from '../../themes/';
import { useBrand } from './BrandProvider';
import ResponsiveProvider from './ResponsiveProvider';
import { useVersion } from './VersionProvider';

export const ThemeProvider = ({ children }) => {
  const brand = useBrand();
  const version = useVersion();
  const isCobalt = version === 'cobalt';
  const themeName = isCobalt ? `COBALT_${brand}` : brand;
  const theme = themes[themeName];
  return (
    <EmotionThemeProvider theme={theme}>
      <ResponsiveProvider>{children}</ResponsiveProvider>
    </EmotionThemeProvider>
  );
};
